import type { Maybe } from '@/types/globals';
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { RxNote } from '@modules/notes/models/rx-note';

export interface AlignTechNotesState {
	alignTechNotesArray: Maybe<RxNote[]>;
	alignTechNotes: Maybe<string>;
}

export const createInitialState = (): AlignTechNotesState => ({
	alignTechNotesArray: null,
	alignTechNotes: null
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'aligntech-notes' })
export class AlignTechNotesStore extends Store<AlignTechNotesState> {
	constructor() {
		super(createInitialState());
	}
}
